// ------------------------------------
// Smooth Scroll (Scroll Suave)
// ------------------------------------
// Exemplo: <a href="smooth:id_do_elemento">Âncora</a>
(function () {
  'use strict';

  // Variáveis
  const $links = $('a[href^="smooth:"]');

  // Scroll ao clicar em um link âncora
  $links.click(function (ev) {
    ev.preventDefault();
    const elementId = $(this).attr('href').replace('smooth:', '');
    const headerHeight = $('.main-header').height(); // Altura do header (Caso seja fixo)
    const gap = 20; // Espaçamento entre o topo e o elemento
    const offsetTop = headerHeight + gap;
    smoothScroll('#' + elementId, offsetTop);
  });
})();

// Scroll suave para um determinado elemento
function smoothScroll(element, offsetTop = 0) {
  offsetTop = offsetTop < 0 ? 0 : offsetTop;
  const top = $(element).length > 0 ? $(element).offset().top - offsetTop : 0;
  $('html, body').animate(
    {
      scrollTop: top,
    },
    500,
  );
}
